module.exports = __webpack_public_path__ + "img/xidi.2fda06bc.png";